
import { AssetCategory, IGetAssetCategoryDto } from './AssetCategory';
import { Division, IGetDivisionDto } from './Division';


export enum AssetCategoriesAndDivisionsAvailability {
    available = "available",
    inUse = 'inUse'
}

export interface IGetAssetCategoriesAndDivisionsDto {
   assetCategories: IGetAssetCategoryDto[],
   divisions: IGetDivisionDto[]
}

export default class AssetCategoriesAndDivisions {
    assetCategories: AssetCategory[]
    divisions: Division[]

    constructor({assetCategories, divisions}: IGetAssetCategoriesAndDivisionsDto) {
       this.assetCategories = assetCategories.map(acDto=>new AssetCategory(acDto));
       this.divisions = divisions.map(dDto=> new Division(dDto));
    }
}
